import { render, staticRenderFns } from "./custom-return.vue?vue&type=template&id=8f066e00"
import script from "./custom-return.vue?vue&type=script&lang=js"
export * from "./custom-return.vue?vue&type=script&lang=js"
import style0 from "./custom-return.vue?vue&type=style&index=0&id=8f066e00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports